import { render, staticRenderFns } from "./资产招商.vue?vue&type=template&id=9d0926a0&scoped=true"
import script from "./资产招商.vue?vue&type=script&lang=js"
export * from "./资产招商.vue?vue&type=script&lang=js"
import style0 from "./资产招商.vue?vue&type=style&index=0&id=9d0926a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0926a0",
  null
  
)

export default component.exports